Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports.default = undefined;
exports.student = undefined;

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

const _getAuth = _interopRequireDefault(require('./getAuth'));

const getStudentFromResults = (students) => students.at(0);

/**
 * Memoized version of getStudents so that as long as we are getting the same student we aren't hitting datastore multiple times
 */
const student = {
    cache: {},
    clearMemoization() {
        this.cache = {};
    },
    getStudentMemoized() {
        return async (datastore) => {
            const sisStudentid = await _getAuth.default({ datastore });

            if (!sisStudentid) {
                return Promise.resolve({});
            }

            const argsString = JSON.stringify(sisStudentid);

            if (this.cache[argsString]) {
                return this.cache[argsString].then(getStudentFromResults);
            }

            const result = datastore
                .collection('students')
                .where('sisStudentid', '===', sisStudentid)
                .get();

            this.cache[argsString] = result;

            return result.then(getStudentFromResults);
        };
    },
};

exports.student = student;
const getStudent = student.getStudentMemoized();
const _default = getStudent;
exports.default = _default;
